import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  button: css`
    align-items: center;
    border: unset;
    border-radius: ${spacing(12.5)};
    cursor: pointer;
    display: flex;
    height: ${spacing(4)};
    justify-content: center;
    padding: ${spacing(0, 1.75)};
    width: 100%;
  `,
  copyButton: css`
    background-color: ${cssTheme.default.day.backgroundMinor};
  `,
  downloadButton: css`
    background-color: ${cssTheme.colors.blue.toxic};
  `,
  copyIcon: css`
    display: block;
    color: #0596fa;
  `,
}
